import React from "react";
import Head from "next/head";
import { Hooks } from "@xt/xtbase";
const { useIntl } = Hooks;

import Alternate from "./Alternate";
import Social from "./Social";

const DEFAULT_SITE_TITLES = {
  en: "Spikex | AI Crypto Trading & Copy Trading Platform",
  "zh-CN": "Spikex | AI 加密货币交易 & 跟单交易平台",
  "zh-HK": "Spikex | AI 加密貨幣交易 & 跟單交易平台",
  pt: "Spikex | Negociação de criptomoedas com IA e copy trading",
  ar: "Spikex | تداول العملات المشفرة بالذكاء الاصطناعي ونسخ الصفقات",
  vi: "Spikex | Nền tảng giao dịch crypto AI & copy trading",
};

/** CMS 未返回 describe 时兜底（与 ssr-web-index Seo 一致） */
const DEFAULT_DESCRIPTION = {
  en: "Spikex is an AI-powered crypto, forex, and commodities trading platform with Futures, smart tools, and copy trading—built for secure, global execution.",
  "zh-CN":
    "Spikex 是面向加密货币、外汇与大宗商品的 AI 驱动交易平台，支持期货与跟单交易，安全、全球化服务。",
  "zh-HK":
    "Spikex 是面向加密貨幣、外匯與大宗商品的 AI 驅動交易平台，支援期貨與跟單交易，安全、全球化服務。",
  pt: "A Spikex é uma plataforma de negociação com IA para criptomoedas, forex e commodities, com Futuros, ferramentas inteligentes e copy trading—segura e global.",
  ar: "سبيكس منصة تداول مدعومة بالذكاء الاصطناعي للعملات المشفرة والفوركس والسلع، مع العقود الآجلة والأدوات الذكية ونسخ الصفقات—آمنة وعالمية.",
};

function normalizeTdk(raw = {}) {
  const tdk = raw?.data && typeof raw.data === "object" ? raw.data : raw;
  let keyword = tdk.keyword;
  if (typeof keyword === "string") {
    keyword = keyword.split(",").map((s) => s.trim()).filter(Boolean);
  } else if (!Array.isArray(keyword)) {
    keyword = ["Spikex"];
  }
  return { ...tdk, keyword };
}

export default function SEO({ tdk: tdkProp = {}, resolvedUrl, locale = "en", basePath = "accounts" }) {
  const intl = useIntl();
  const tdk = normalizeTdk(tdkProp);

  const rawTitle = typeof tdk.title === "string" ? tdk.title.trim() : "";
  const title = !rawTitle || rawTitle === "Spikex"
    ? (DEFAULT_SITE_TITLES[locale] || DEFAULT_SITE_TITLES.en)
    : rawTitle;

  const rawDescribe = typeof tdk.describe === "string" ? tdk.describe.trim() : "";
  let description = rawDescribe || DEFAULT_DESCRIPTION[locale] || DEFAULT_DESCRIPTION.en;
  if (!description) {
    try {
      description = intl.formatMessage({ id: "app.description" });
    } catch {
      description = DEFAULT_DESCRIPTION.en;
    }
  }

  const keywords = tdk.keyword;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(",")} />
      <meta
        name="viewport"
        content="minimal-ui,width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
      />
      <Alternate resolvedUrl={resolvedUrl} locale={locale} basePath={basePath} />
      <Social
        title={title}
        description={description}
        resolvedUrl={resolvedUrl}
        locale={locale}
        basePath={basePath}
      />
    </Head>
  );
}
